import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

import {ViewerModule} from '@app/viewer/viewer.module';

import {EmbedRoutingModule} from './embed-routing.module';
import {EmbedComponent} from './embed/embed.component';

@NgModule({
    imports: [
        CommonModule,
        EmbedRoutingModule,
        ViewerModule,
        MatIconModule,
        MatProgressSpinnerModule,
        EmbedComponent,
    ],
})
export class EmbedModule {}
